import { Routes } from '@angular/router';
import { DetailsResolver } from './features/jobs/services/details-resolver.service';
import { ApplyOnlineGuards } from './core/guards/apply-online-guards';
import { CareerStructure } from './features/career/career-structure/career-structure';


export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/pages/home/home').then(c => c.Home)
  },

  {
    path: 'details/:id',
    loadComponent: () =>
      import('./features/pages/details/details').then((c) => c.Details),
    resolve: { detail: DetailsResolver },
    data: {
      hideTopSection: true,
    }
  },
  {
    path: 'apply-online',
    loadComponent: () =>
      import('./features/pages/apply-page/apply-page').then(
        (c) => c.ApplyPage
      ),
    title: 'Apply Online',
    children: [
      {
        path: 'free-limit-reached',
        loadComponent: () =>
          import('./features/pages/non-pro-limit-over/non-pro-limit-over').then(
            (c) => c.NonProLimitOver
          ),
      },
      {
        path: 'pro-limit-reached',
        loadComponent: () =>
          import('./features/pages/pro-limit-over/pro-limit-over').then(
            (c) => c.ProLimitOver
          ),
      },
      {
        path: 'not-elligible',
        loadComponent: () =>
          import('./features/pages/not-elligible/not-elligible').then(
            (c) => c.NotElligible
          ),
      },
      {
        path: 'update-cv',
        loadComponent: () =>
          import('./features/pages/update-cv/update-cv').then(
            (c) => c.UpdateCv
          ),
      },
      {
        path: 'profile-incomplete',
        loadComponent: () =>
          import('./features/pages/profile-complete/profile-complete').then(
            (c) => c.ProfileComplete
          ),
      },
      {
        path: 'complete',
        loadComponent: () =>
          import('./features/pages/apply-complete/apply-complete').then(
            (c) => c.ApplyComplete
          ),
      },
      {
        path: 'job-not-available',
        loadComponent: () =>
          import('./features/pages/job-not-available/job-not-available').then(
            (c) => c.JobNotAvailable
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./features/pages/apply-online/apply-online').then(
            (c) => c.ApplyOnline
          ),
        canActivate: [ApplyOnlineGuards],
      },

    ],
    data: {
      hideTopSection: true,
    }
  },
  {
    path: 'jobs',
    loadComponent: () =>
      import('./features/pages/jobs/jobs').then((c) => c.Jobs),
    data: {
      hideTopSection: true,
    }
  },

  {
    path: 'contact-info',
    loadComponent: () =>
      import('./features/contact-info/components/contact-info/contact-info').then(c => c.ContactInfo),
pathMatch: 'full'
  },
  {
    path: 'about-us',
    loadComponent: () =>
      import('./features/about-us/components/about-us/about-us').then((c) => c.AboutUs),

  },

  {
    path: 'akm-fahim-mashroor',
    loadComponent: () =>

      import('./features/about-us/components/akm-fahim-mashroor/akm-fahim-mashroor/akm-fahim-mashroor')
        .then(m => m.AkmFahimMashroor),
  },
  {
    path: 'terms-condition',
    loadComponent: () => import('./features/about_us/components/terms-condition/terms-condition').then(c => c.TermsCondition)

  },
  {
    path: 'Accessibility-Statement',
    loadComponent: () => import('./features/about_us/components/statement/statement').then(c => c.Statement)

  },
  {
    path: 'policy', loadComponent: () => CareerStructure,
    loadChildren: () => import('./features/about_us/route/about-us-route').then(c => c.ABOUT_ROUTES)
  },
  {
    path: 'career', loadComponent: () => CareerStructure,
    loadChildren: () => import('./features/career/services/career.routes').then(c => c.CAREER_ROUTES)
  },
  {
    path: 'company-insight/:id',
    loadComponent: () => import('./features/pages/company-insight/company-insight').then(c => c.CompanyInsight),
     data: {
      hideTopSection: true,
    }
  },
  {
    path: 'company-list',
    loadComponent: () =>
      import('./features/pages/employer-list/employer-list')
        .then(c => c.EmployerList),
    data: {
      hideTopSection: true,
    }
  },


  {
    path:'feedback',
    loadComponent: () => import('./features/pages/feedbackpage/feedbackpage').then(c => c.Feedbackpage),
    data: {
      hideTopSection: true,
    }
  },

  {
    path: 'feedbackSubmited',
    loadComponent: () => import('./features/feedback/feedback-sumitted/feedback-sumitted.component').then(c => c.FeedbackSumittedComponent),
    data: {
      hideTopSection: true,
    }
  },

  {
    path: 'not-found',
    loadComponent: () => import('./features/pages/not-found/not-found').then(c => c.NotFound),
    data: { hideTopSection: true }
  },

  {
    path: '**',
    loadComponent: () => import('./features/pages/not-found/not-found').then(c => c.NotFound),    
    data: { hideTopSection: true }
  }

];
